import { Routes } from "@angular/router";
import { AddProgramComponent } from "./components/add-program/add-program.component";
import { ProgramSummaryComponent } from "./components/program-summary/program-summary.component";
import { ProgramsListingComponent } from "./components/programs-listing/programs-listing.component";
import { ProgramsComponent } from "./programs.component";

export const programRoutes: Routes = [
  { path: "", component: ProgramsComponent },
  { path: "program-listing", component: ProgramsListingComponent },
  { path: "program-header", component: AddProgramComponent },
  { path: "program-summary/:id", component: ProgramSummaryComponent },
];
